import * as React from 'react';

// Define props extending standard SVG attributes
interface CreatorProfileIconProps extends React.SVGProps<SVGSVGElement> {}

export const CreatorProfileIcon = React.memo(({
  width = 16, // Default width
  height = 16, // Default height
  viewBox = '0 0 16 16', // Default viewBox
  ...props
}: CreatorProfileIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none" // Parent SVG fill set to none or a default if necessary
    xmlns="http://www.w3.org/2000/svg"
    {...props} // Spread other SVG props like className, onClick etc.
  >
    <path
      transform="translate(2.375, 2)"
      d="M6 6C4.33594 6 3 4.66406 3 3C3 1.35938 4.33594 0 6 0C7.64062 0 9 1.35938 9 3C9 4.66406 7.64062 6 6 6ZM7.17188 7.125C9.42188 7.125 11.25 8.95312 11.25 11.2031C11.25 11.6484 10.875 12 10.4297 12H1.54688C1.10156 12 0.75 11.6484 0.75 11.2031C0.75 8.95312 2.55469 7.125 4.80469 7.125H7.17188Z"
      fill="currentColor" // Path fill inherits color from text- SvgIcon className
    />
  </svg>
));

CreatorProfileIcon.displayName = 'CreatorProfileIcon';

// Default export is not conventional for multiple named icon exports from an index file,
// but keeping it if it was intentional for direct imports elsewhere.
// If all icons are imported like `import { IconName } from '@/components/icons'`, default export is not strictly needed.
export default CreatorProfileIcon;
